import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/events/deleteStream';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(data) {
  const stream = data.payload?.stream || data.payload;
  try {
    yield call(
      axios.delete,
      `${config.API_URL}/event/streams/${encodeURIComponent(stream)}`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(stream));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
